import { render, staticRenderFns } from "./ProfilePasswordTab.vue?vue&type=template&id=7483af0f"
import script from "./ProfilePasswordTab.vue?vue&type=script&lang=js"
export * from "./ProfilePasswordTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports